import Brightness1Icon from "@mui/icons-material/Brightness1";
import {
  StepConnector,
  StepIconProps,
  stepConnectorClasses,
  styled
} from "@mui/material";

export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main
    }
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.success.main
    }
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800]
    })
  }
}));

export const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme }) => ({
  backgroundColor: "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...theme.applyStyles("dark", {
    backgroundColor: theme.palette.grey[700]
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundColor: theme.palette.primary.main,
        boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)"
      }
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundColor: theme.palette.success.main
      }
    }
  ]
}));

export const ColorlibStepIcon = (props: StepIconProps) => {
  const { active, completed, className } = props;

  const icons: {
    [index: string]: { icon: React.ReactElement<unknown> };
  } = {
    1: {
      icon: <Brightness1Icon />
    },
    2: {
      icon: <Brightness1Icon />
    },
    3: {
      icon: <Brightness1Icon />
    },
    4: {
      icon: <Brightness1Icon />
    },
    5: {
      icon: <Brightness1Icon />
    }
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)].icon}
    </ColorlibStepIconRoot>
  );
};
